(function (Drupal, $, once) {
  'use strict';

  Drupal.behaviors.slickLastSlidePadding = {
    attach: function (context, settings) {
      const checkAndInitSliders = function() {
        $('.paragraph--type--slider .slick-slider', context).each(function() {
          const $slider = $(this);

          if ($slider.data('slickLastPaddingInitialized')) return;
          $slider.data('slickLastPaddingInitialized', true);

          const $slickList = $slider.find('.slick-list');

          $slickList.css('transition', 'padding 0.5s ease-in-out');

          const applyPadding = function() {

            const slickInstance = $slider.slick('getSlick');

            let slidesToShow = slickInstance.options.slidesToShow || 1;
            if (slickInstance.options.responsive) {
              slickInstance.options.responsive.forEach(r => {
                if ($(window).width() <= r.breakpoint && r.settings && r.settings.slidesToShow) {
                  slidesToShow = r.settings.slidesToShow;
                }
              });
            }

            const slideCount = slickInstance.slideCount;
            const currentSlide = slickInstance.currentSlide;
            const isLastSet = currentSlide >= (slideCount - slidesToShow);
            const viewportWidth = $(window).width();

            if (isLastSet) {
              $slickList.css({
                'padding-left': viewportWidth < 768 ? 'calc(15% - 1rem)' : '15%',
                'padding-right': '0'
              });
            } else {
              $slickList.css({
                'padding-left': '0',
                'padding-right': '15%'
              });
            }

            return true;
          };

          // Event Listener
          const initHandler = function() {
            setTimeout(applyPadding, 100); // kleines Delay für Browser-Kompatibilität
          };

          $slider.on('init', initHandler);
          $slider.on('afterChange', initHandler);
          $(window).on('resize.slickLastSlidePadding', initHandler);

          if ($slider.hasClass('slick-initialized')) {
            initHandler();
          }
        });
      };

      checkAndInitSliders();

      const observer = new MutationObserver(function() {
        checkAndInitSliders();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  };
})(Drupal, jQuery, once);
